/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Missing_PartsInputs */

const en_val_missing_parts = /** @type {(inputs: Val_Missing_PartsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing Parts`)
};

const es_val_missing_parts = /** @type {(inputs: Val_Missing_PartsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faltan piezas`)
};

const fr_val_missing_parts = /** @type {(inputs: Val_Missing_PartsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pièces manquantes`)
};

const de_val_missing_parts = /** @type {(inputs: Val_Missing_PartsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlende Teile`)
};

const ja_val_missing_parts = /** @type {(inputs: Val_Missing_PartsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一部欠品あり`)
};

const zh_val_missing_parts = /** @type {(inputs: Val_Missing_PartsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`缺少零件`)
};

const ar_val_missing_parts = /** @type {(inputs: Val_Missing_PartsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أجزاء مفقودة`)
};

const id_val_missing_parts = /** @type {(inputs: Val_Missing_PartsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komponen Hilang`)
};

const it_val_missing_parts = /** @type {(inputs: Val_Missing_PartsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parti Mancanti`)
};

const ru_val_missing_parts = /** @type {(inputs: Val_Missing_PartsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отсутствуют детали`)
};

const pt_val_missing_parts = /** @type {(inputs: Val_Missing_PartsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peças Faltando`)
};

const ko_val_missing_parts = /** @type {(inputs: Val_Missing_PartsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`부품 일부 누락됨`)
};

/**
* | output |
* | --- |
* | "Missing Parts" |
*
* @param {Val_Missing_PartsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_missing_parts = /** @type {((inputs?: Val_Missing_PartsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Missing_PartsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_missing_parts(inputs)
	if (locale === "es") return es_val_missing_parts(inputs)
	if (locale === "fr") return fr_val_missing_parts(inputs)
	if (locale === "de") return de_val_missing_parts(inputs)
	if (locale === "ja") return ja_val_missing_parts(inputs)
	if (locale === "zh") return zh_val_missing_parts(inputs)
	if (locale === "ar") return ar_val_missing_parts(inputs)
	if (locale === "id") return id_val_missing_parts(inputs)
	if (locale === "it") return it_val_missing_parts(inputs)
	if (locale === "ru") return ru_val_missing_parts(inputs)
	if (locale === "pt") return pt_val_missing_parts(inputs)
	return ko_val_missing_parts(inputs)
});